export {
  clearPrinterError,
  clearPrinterState,
  default as printersReducer,
} from './printerSlice';

export {
  selectActivePrinters,
  selectBillPrinterIdByTakeAwayDevice,
  selectBillPrinterIdBySection,
  selectDepartmentPrinterMapByTakeAwayDevice,
  selectDepartmentPrinterMapBySection,
  selectInstalledPrinters,
  selectOutletPrinters,
  selectPrinterDeviceId,
  selectPrinterById,
  selectPrinterOptions,
  selectPrintersError,
  selectPrintersLoading,
  selectPrintersSaving,
  selectPrintersTesting,
  selectSectionHasPrinterConfiguration,
  selectSectionPrinterMappings,
  selectTakeAwayPrinterMappings,
} from './printerSelectors';

export {
  createOutletPrinterThunk,
  fetchPrinterDeviceIdThunk,
  fetchInstalledPrintersThunk,
  fetchOutletPrintersThunk,
  fetchTakeAwayPrinterMappingsThunk,
  fetchSectionPrinterMappingsThunk,
  saveTakeAwayPrinterConfigThunk,
  saveSectionPrinterConfigThunk,
  testPrinterConnectionThunk,
} from './printerThunks';
